import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
export function Experimental__IconPause(props) {
  var iconList = [{
    "size": 16,
    "svgContent": "<path fill=\"none\" d=\"M0 0h16v16H0z\"/><path d=\"M3 2h3v12H3zm7 0h3v12h-3z\"/>"
  }, {
    "size": 24,
    "svgContent": "<path fill=\"none\" d=\"M0 0h24v24H0z\"/><path d=\"M5 3h4v18H5zm10 0h4v18h-4z\"/>"
  }, {
    "size": 32,
    "svgContent": "<path fill=\"none\" d=\"M0 0h32v32H0z\"/><path d=\"M20 5v22c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1zM7 28h4c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1v22c0 .6.4 1 1 1z\"/>"
  }, {
    "size": 48,
    "svgContent": "<path fill=\"none\" d=\"M0 0h48v48H0z\"/><path d=\"M16.5 42h-5c-.8 0-1.5-.7-1.5-1.5v-33c0-.8.7-1.5 1.5-1.5h5c.8 0 1.5.7 1.5 1.5v33c0 .8-.7 1.5-1.5 1.5zm20 0h-5c-.8 0-1.5-.7-1.5-1.5v-33c0-.8.7-1.5 1.5-1.5h5c.8 0 1.5.7 1.5 1.5v33c0 .8-.7 1.5-1.5 1.5z\"/>"
  }, {
    "size": 64,
    "svgContent": "<path fill=\"none\" d=\"M0 0h64v64H0z\"/><path d=\"M40 11v42c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V11c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2zM14 55h8c1.1 0 2-.9 2-2V11c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v42c0 1.1.9 2 2 2z\"/>"
  }];
  var iconListRedraw = [{
    "size": 16,
    "svgContent": "<path d=\"M2.7 1a.7.7 0 00-.7.7v12.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V1.7a.7.7 0 00-.7-.7H2.7zm8 0a.7.7 0 00-.7.7v12.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V1.7a.7.7 0 00-.7-.7h-2.6z\"/>"
  }, {
    "size": 24,
    "svgContent": "<path d=\"M5.7 3a.7.7 0 00-.7.7v16.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V3.7a.7.7 0 00-.7-.7H5.7zm10 0a.7.7 0 00-.7.7v16.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V3.7a.7.7 0 00-.7-.7h-2.6z\"/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.next ? iconListRedraw : iconListFallback, props.iconSize || 24);
  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: closestSize.svgContent
    }
  }));
}
export default Experimental__IconPause;